import { velynkService } from "./base";

export const consentSend = (params) => {
  const url = "acknowledgement_logs";
  return velynkService.post(url, params);
};
